export const contain = { label: '包含', value: 'contain' };
export const notContain = { label: '不包含', value: 'not_contain' };
export const equal = { label: '等于', value: 'eq' };
export const notEqual = { label: '不等于', value: 'neq' };
export const exist = { label: '不为空', value: 'exist', disabled: true };
export const notExist = { label: '为空', value: 'not_exist', disabled: true };
export const gt = { label: '大于', value: 'gt' };
export const geqt = { label: '大于等于', value: 'gt' };
export const lt = { label: '小于', value: 'lt' };
export const range = { label: '范围', value: 'range' };
export const startWith = { label: '开头匹配', value: 'start_with' };
export const endWith = { label: '结尾匹配', value: 'end_with' };
export const yes = { label: '是', value: 'contain' };
export const no = { label: '否', value: 'not_contain' };
// 默认的日期时间查询条件
export const dateCondition = [range, equal, notEqual, contain, notContain, exist, notExist];

// 默认的文本查询条件
export const stringCondition = [equal, notEqual, contain, notContain, notExist, exist];

// 默认的数字查询条件
export const numberCondition = [equal, notEqual, notExist, exist];

// 默认的单选查询条件
export const radioCondition = [equal, notEqual];

// 默认的多选查询条件
export const checkCondition = [contain, notContain];

export const allCondition = [range, equal, notEqual, contain, notContain, exist, notExist, gt, lt];

export default {
  equal,
  notEqual,
  contain,
  notContain,
  exist,
  notExist,
  gt,
  geqt,
  lt,
  range,
  startWith,
  endWith,
  dateCondition,
  stringCondition,
  numberCondition,
  radioCondition,
  checkCondition,
  allCondition,
  yes,
  no
};
